import script from "./QueueView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueView.vue?vue&type=script&setup=true&lang=js"

import "./QueueView.vue?vue&type=style&index=0&id=fd501978&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd501978"]])

export default __exports__